export default "__VITE_ASSET__Bz7jnwJW__"